
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const ConfirmationModal = ({
  show,
  onClose,
  icon,
  title,
  message,
  primaryText = 'Confirm',
  secondaryText = 'Cancel',
  onPrimary,
  onSecondary
}) => {
  if (!show) return null;

  const modalContent = (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100dvw',
        height: '100dvh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        overflowY: 'auto',
        zIndex: 9999,
        padding: '16px',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '500px',
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '24px',
          marginTop: '10vh',
          boxSizing: 'border-box',
          boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
          maxHeight: 'calc(100dvh - 40px)',
          overflowY: 'auto',
          position: 'relative'
        }}
      >
        <button
          type="button"
          style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            background: 'transparent',
            border: 'none',
            fontSize: '24px',
            fontWeight: 'normal',
            color: 'black',
            cursor: 'pointer',
            lineHeight: '1'
          }}
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>

        {icon && (
          <div style={{ textAlign: 'center', marginBottom: 16, marginTop: 16 }}>
            <img src={icon} alt="Modal Icon" style={{ height: '50px', width: '50px' }} />
          </div>
        )}

        <h5 style={{ textAlign: 'center', marginBottom: 12, fontWeight: 'bold' }}>{title}</h5>
        <p style={{ textAlign: 'center', marginBottom: 24, color: '#000000' }}>{message}</p>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            type="button"
            style={{
              flexGrow: 1,
              backgroundColor: '#C9194A',
              color: '#fff',
              border: 'none',
              height: '40px',
              borderRadius: '16px'
            }}
            onClick={onPrimary}
          >
            {primaryText}
          </button>

          <button
            type="button"
            style={{
              flexGrow: 1,
              backgroundColor: '#fff',
              color: '#6C757D',
              border: '1px solid #DEE2E6',
              height: '40px',
              fontWeight: 'bold',
              borderRadius: '16px'
            }}
            onClick={onSecondary || onClose}
          >
            {secondaryText}
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

ConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  icon: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  onPrimary: PropTypes.func,
  onSecondary: PropTypes.func
};

export default ConfirmationModal;
